import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Home from '../views/Home.vue'

import AllDataPageList from '../views/allDataPage/allDataPageList'
// 登录页
import LoginPage from '../views/login/loginPage'

// 设备详情
import SceneList from '../views/equipment/sence/sceneList'

//
import DataConfig from '../views/systemManagement/DataConfig/DataConfigForm'
// 数据展示
import dataPlay from '../views/equipment/sence/dataPlay'

import EquipmentList from '../views/equipment/equipment/equipmentList'
import VideoList from '../views/video/videoList'
// 设备详情内容
import EquipmentDetails from '../views/equipment/equipmentDetails/equipmentDetails'
import EquipmentDataList from '../views/equipment/equipmentDetails/equipmentData/equipmentDataList'
// 设备控制
import EquipmentControlList from '../views/equipment/equipmentDetails/equipmentControl/equipmentControlList'
// 报警事件
import AlarmEventsList from '../views/equipment/equipmentDetails/alarmEvents/alarmEventsList'
/// 自动控制
import AutoControlList from '../views/equipment/equipmentDetails/autoControl/autoControlList'
// 智能推送
import IntelligentPushList from '../views/equipment/equipmentDetails/intelligentPush/intelligentPushList'
// 智能预测
import IntelligentPrediction from '../views/equipment/equipmentDetails/intelligentPrediction/intelligentPrediction'

//分干管主干管支管出地桩
import EntWLWCropWaterPipeList from '../views/precisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeList'
import EntWLWCropWaterPipeAdd from '../views/precisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeAdd'
import EntWLWCropWaterPipeAdd2 from '../views/precisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeAdd2'


//能耗分析
import EnergyanalsisDetails from '../views/energyanalsis/equipmentDetails/equipmentDetails'
import EnergyanalsisDataList from '../views/energyanalsis/equipmentDetails/equipmentData/equipmentDataList'
import EnergyanalsisControlList from '../views/energyanalsis/equipmentDetails/equipmentControl/equipmentControlList'

// 灌水计划
import IrrigationPlanList from '../views/precisionIrrigation/IrrigationPlan/IrrigationPlanList'
import RotationIrrigationPlanList from '../views/precisionIrrigation/RotationIrrigationPlan/RotationIrrigationPlanList'
import RotationalIrrigationSystemList from '../views/precisionIrrigation/RotationalIrrigationSystem/RotationalIrrigationSystemList'
import IntelligentDecisionMakingList from '../views/precisionIrrigation/intelligentDecisionMaking/intelligentDecisionMakingList'
// 灌水计划新增
import precisionIrrigationNewAdd from '../views/precisionIrrigation/IrrigationPlan/precisionIrrigationNewAdd'
// 轮灌计划新增
import RotationIrrigationPlanNewAdd from '../views/precisionIrrigation/RotationIrrigationPlan/RotationIrrigationPlanNewAdd'
/// 轮灌编制新增
import RotationalIrrigationSystemNewAdd from '../views/precisionIrrigation/RotationalIrrigationSystem/RotationalIrrigationSystemNewAdd'


// 生产管理
//员工信息管理
import EmployeeManagementlist from '../views/productionManagement/employeemanagement/employeemanagementlist'
// 员工信息管理新增
import EmployeeManagementNewAdd from '../views/productionManagement/employeemanagement/EmployeeManagementNewAdd'
//农事记录
import FarmingRecordlist from '../views/productionManagement/farmingrecord/farmingrecordlist'
//农事记录新增
import FarmingRecordNewAdd from '../views/productionManagement/farmingrecord/FarmingRecordNewAdd'
//工单管理
import WorkorderManagementlist from '../views/productionManagement/workordermanagement/workordermanagementlist'
//工单管理新增
import WorkOrderManagementNewAdd from '../views/productionManagement/workordermanagement/WorkOrderManagementNewAdd'
//工单管理派发
import WorkOrderManagementDist from '../views/productionManagement/workordermanagement/WorkOrderManagementDist'

//能耗分析
import Energyanalsis from '../views/energyanalsis/energyanalsis'
//能耗分析详情
import energyDetails from '../views/energyanalsis/energyDetails'


// 农技服务
// 种植指导
import PlantingInstructionList from '../views/agriculturalServices/plantingInstruction/plantingInstructionList'
// 病害虫管理
import PestManagement from '../views/agriculturalServices/pestManagement/pestManagement'
// 产量预测
import ProductionForecastList from '../views/agriculturalServices/productionForecast/productionForecastList'

// 角色管理
import PropertyList from "../views/systemManagement/propertyManagement/propertyManagement"
import PropertyForm from "../views/systemManagement/propertyManagement/propertyManagementForm"





// 系统管理
// 基础信息
import BasicInformationList from '../views/systemManagement/basicInformation/basicInformationList'
// 操作日志
import LogList from '../views/systemManagement/log/logList'
// 项目管理
import platformManagementList from '../views/platformManagement/platformManagement/platformManagementList'
// 用户管理
import UserList from "../views/systemManagement/user/userList"
import UserForm from "../views/systemManagement/user/userForm"

import PlatformManagementForm from "../views/equipmentManagement/platformManagement/platformManagementForm"
// 场地管理
import sceneManagementList from '../views/platformManagement/sceneManagement/sceneManagementList'

import SceneManagementForm from "../views/equipmentManagement/sceneManagement/sceneManagementForm"

import SceneManagementMapForm from "../views/equipmentManagement/sceneManagement/SceneManagementMapForm"
// 设备分配
import deviceAllocationList from '../views/platformManagement/deviceAllocation/deviceAllocationList'
// 视频管理
import videoManagementList from '../views/platformManagement/videoManagement/videoManagementList'

import VideoManagementForm from "../views/equipmentManagement/videoManagement/videoManagementForm"

//系统主页


import LargerScreenPage from '../views/largerScreen/largerSiderPage'
import LargerScreenSiderPage from '../views/largerScreen/largerSiderPage'


import Layout from '../views/Layout.vue'


Vue.use(VueRouter)

const routes = [
  // 数据展示
  {
    path: '/allDataPage/allDataPageList',
    name: 'AllDataPageList',
    component: AllDataPageList,
    meta: {
      title: '水产平台-',
      requiresAuth: true
    }
  },{
    path: '/Layout',
    name: 'Layout',
    component: Layout,
    children:[
      {
        path: '/Home',
        name: 'Home',
        component: Home
      },
      {
        path: '/equipment/sence/sceneList',
        name: 'SceneList',
        component: SceneList
      },
      {
        path: '/equipment/equipment/equipmentList',
        name: 'EquipmentList',
        component: EquipmentList
      },
      //系统主页
      {
        path: '/largerScreen/largerSiderPage',
        name: 'LargerScreenSiderPage',
        component: LargerScreenSiderPage,
        meta: {
          title: '水产平台-',
          requiresAuth: true
        }
      },
      {
        path: '/largerScreen111/largerScreenPage111',
        name: 'LargerScreenPage',
        component: LargerScreenPage,
        meta: {
          requiresAuth:true
        }
      },
      // 视频列表
      {
        path: '/video/videoList',
        name: 'VideoList',
        component: VideoList
        ,meta: {
          requiresAuth:true
        }
      },

      // 灌水计划
      {
        path: '/precisionIrrigation/IrrigationPlan/IrrigationPlanList',
        name: 'IrrigationPlanList',
        component: IrrigationPlanList
      },
      // 灌水计划新增
      {
        path: '/precisionIrrigation/IrrigationPlan/precisionIrrigation',
        name: 'precisionIrrigationNewAdd',
        component: precisionIrrigationNewAdd
      },

      {
        path: '/precisionIrrigation/RotationIrrigationPlan/RotationIrrigationPlanList',
        name: 'RotationIrrigationPlanList',
        component: RotationIrrigationPlanList
      },
      // 轮灌计划新增
      {
        path: '/precisionIrrigation/RotationIrrigationPlan/RotationIrrigationPlanNewAdd',
        name: 'RotationIrrigationPlanNewAdd',
        component: RotationIrrigationPlanNewAdd
      },
      {
        path: '/precisionIrrigation/RotationalIrrigationSystem/RotationalIrrigationSystemList',
        name: 'RotationalIrrigationSystemList',
        component: RotationalIrrigationSystemList
      },
      // 轮灌编制新增
      {
        path: '/precisionIrrigation/RotationalIrrigationSystem/RotationalIrrigationSystemNewAdd',
        name: 'RotationalIrrigationSystemNewAdd',
        component: RotationalIrrigationSystemNewAdd
      },
      {
        path: '/precisionIrrigation/intelligentDecisionMaking/intelligentDecisionMakingList',
        name: 'IntelligentDecisionMakingList',
        component: IntelligentDecisionMakingList
      },


      {
        path: '/energyanalsis/equipmentDetails',
        name: 'EnergyanalsisDetails',
        component: EnergyanalsisDetails,
        children:[
          // 设备数据
          {
            // path: '/equipment/equipmentDetails/equipmentData/equipmentDataList',
            path: '/energyanalsis/equipmentDetails',
            // path:"/",
            name: 'EnergyanalsisDataList',
            component: EnergyanalsisDataList
            ,meta: {
              requiresAuth:true
            }
          },
          // 设备控制
          {
            path: '/energyanalsis/equipmentDetails/equipmentControl/equipmentControlList',
            // path:"/",
            name: 'EnergyanalsisControlList',
            component: EnergyanalsisControlList ,
            meta: {
              requiresAuth:true
            }
          }


        ]}, // 能耗分析




      {
        path: '/equipment/equipmentDetails',
        name: 'EquipmentDetails',
        component: EquipmentDetails,
        children:[
          // 设备数据
          {
            // path: '/equipment/equipmentDetails/equipmentData/equipmentDataList',
            path: '/equipment/equipmentDetails',

            // path:"/",
            name: 'equipmentDataList',
            component: EquipmentDataList
            ,meta: {
              requiresAuth:true
            }
          },
          // 设备控制
          {
            path: '/equipment/equipmentDetails/equipmentControl/equipmentControlList',
            // path:"/",
            name: 'equipmentControlList',
            component: EquipmentControlList ,
            meta: {
              requiresAuth:true
            }
          },
          // 报警事件
          {
            path: '/equipment/equipmentDetails/alarmEvents/alarmEventsList',
            // path:"/",
            name: 'alarmEventsList',
            component: AlarmEventsList
            ,meta: {
              requiresAuth:true
            }
          },
          // 自动控制
          {
            path: '/equipment/equipmentDetails/autoControl/autoControlList',
            // path:"/",
            name: 'autoControlList',
            component: AutoControlList
            ,meta: {
              requiresAuth:true
            }
          },
          // 智能推送
          {
            path: '/equipment/equipmentDetails/intelligentPush/intelligentPushList',
            // path:"/",
            name: 'intelligentPushList',
            component: IntelligentPushList
            ,meta: {
              requiresAuth:true
            }
          },
          // 智能预测intelligentPrediction
          {
            path: '/equipment/equipmentDetails/intelligentPrediction/intelligentPrediction',
            // path:"/",
            name: 'intelligentPrediction',
            component: IntelligentPrediction
            ,meta: {
              requiresAuth:true
            }
          }


          ]}, // 项目管理
      {
        path: '/platformManagement/platformManagement/platformManagementList',
        name: 'platformManagementList',
        component: platformManagementList
      },
      // 场地管理
      {
        path: '/platformManagement/sceneManagement/sceneManagementList',
        name: 'sceneManagementList',
        component: sceneManagementList
      },
      // 设备分配
      {
        path: '/platformManagement/deviceAllocation/deviceAllocationList',
        name: 'deviceAllocationList',
        component:deviceAllocationList
      },      {
        path: '/equipmentManagement/videoManagement/videoManagementForm',
        name: 'VideoManagementForm',
        component: VideoManagementForm
        ,meta: {
          requiresAuth:true
        }
      },
      // 视频管理
      {
        path: '/platformManagement/videoManagement/videoManagementList',
        name: 'videoManagementList',
        component: videoManagementList
      },
      {
        path: '/equipmentManagement/sceneManagement/sceneManagementForm',
        name: 'SceneManagementForm',
        component: SceneManagementForm
        ,meta: {
          requiresAuth:true
        }
      },


      {
        path: '/equipmentManagement/sceneManagement/SceneManagementMapForm',
        name: 'SceneManagementMapForm',
        component: SceneManagementMapForm
        ,meta: {
          requiresAuth:true
        }
      },

      {
        path: '/equipmentManagement/platformManagement/platformManagementForm',
        name: 'PlatformManagementForm',
        component: PlatformManagementForm
        ,meta: {
          requiresAuth:true
        }
      },
      // 生产管理

      {
        path: '/productionManagement/employeemanagement/employeemanagementlist',
        name: 'EmployeeManagementlist',
        component: EmployeeManagementlist
      },

      // 员工管理信息新增
      {
        path: '/productionManagement/employeemanagement/EmployeeManagementNewAdd',
        name: 'EmployeeManagementNewAdd',
        component: EmployeeManagementNewAdd
      },

      {
        path: '/productionmanagement/farmingrecord/farmingrecordlist',
        name: 'FarmingRecordlist',
        component: FarmingRecordlist
      },
      // 农事记录新增
      {
        path: '/productionmanagement/farmingrecord/FarmingRecordNewAdd',
        name: 'FarmingRecordNewAdd',
        component: FarmingRecordNewAdd
      },
      {
        path: '/productionmanagement/workordermanagement/workordermanagementlist',
        name: 'WorkorderManagementlist',
        component: WorkorderManagementlist
      },
      //工单管理新增
      {
        path: '/productionmanagement/workordermanagement/WorkOrderManagementNewAdd',
        name: 'WorkOrderManagementNewAdd',
        component: WorkOrderManagementNewAdd
      },
      //工单管理派发
      {
        path: '/productionmanagement/workordermanagement/WorkOrderManagementDist',
        name: 'WorkOrderManagementDist',
        component: WorkOrderManagementDist
      },
      // 农技服务
      // 种植指导
      {
        path: '/agriculturalServices/plantingInstruction/plantingInstructionList',
        name: 'PlantingInstructionList',
        component: PlantingInstructionList
      },
      // 病害虫管理
      {
        path: '/agriculturalServices/pestManagement/pestManagement',
        name: 'PestManagement',
        component: PestManagement
      },
      // 产量预测
      {
        path: '/agriculturalServices/productionForecast/productionForecastList',
        name: 'ProductionForecastList',
        component: ProductionForecastList
      },

      // 系统管理-基础信息
      {
        path: '/systemManagement/basicInformation/basicInformationList',
        name: 'BasicInformationList',
        component: BasicInformationList
        ,meta: {
          requiresAuth:true
        }
      },
      // 系统管理-角色列表
      {
        path: '/systemManagement/propertyManagement/propertyList',
        name: 'PropertyList',
        component: PropertyList
        ,meta: {
          requiresAuth:true
        }
      },
      // 系统管理-数据配置
      {
        path:'/systemManagement/DataConfig/DataConfigForm',
        name :'DataConfig',
        component:DataConfig,
        meta:{
          requiresAuth: true
        }
      },
      {
        path: '/systemManagement/propertyManagement/propertyForm',
        name: 'PropertyForm',
        component: PropertyForm
        ,meta: {
          requiresAuth:true
        }
      },
      // 系统管理-操作日志
      {
        path: '/systemManagement/log/logList',
        name: 'LogList',
        component: LogList
        ,meta: {
          requiresAuth:true
        }
      },
      //能耗分析
      {
        path: '/energyanalsis/energyanalsis',
        name: 'Energyanalsis',
        component: Energyanalsis
      },
      //能耗分析详情
      {
        path: '/energyanalsis/energyDetails',
        name: 'energyDetails',
        component: energyDetails
      },

      // 系统管理-用户列表
      {
        path: '/systemManagement/user/userList',
        name: 'UserList',
        component: UserList
        ,meta: {
          requiresAuth:true
        }
      },
      {
        path: '/systemManagement/user/userForm',
        name: 'UserForm',
        component: UserForm
        ,meta: {
          requiresAuth:true
        }
      },
      {
        path: '/PrecisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeList',
        name: 'EntWLWCropWaterPipeList',
        component: EntWLWCropWaterPipeList,
        meta: {
          requiresAuth:true
        }
      },
      {
        path:'/PrecisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeAdd',
        name:'EntWLWCropWaterPipeAdd',
        component: EntWLWCropWaterPipeAdd,
        meta: {
          requiresAuth:true
        }
      },
      {
        path:'/PrecisionIrrigation/EntWLWCropWaterPipe/EntWLWCropWaterPipeAdd2',
        name:'EntWLWCropWaterPipeAdd2',
        component: EntWLWCropWaterPipeAdd2,
        meta: {
          requiresAuth:true
        }
      },
 ]
  },

  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
